import React from "react";
import { BrowserRouter as Router, Route, Routes, useNavigate } from "react-router-dom";
import ResponsiveDrawer from "./Component/ResponsiveDrawer";
import LoginPage from "./Component/LoginPage";
import EmployeeTable from "./Screens/Employee/EmployeeTable";
import AddEmployee from "./Screens/Employee/AddEmployee";
import ViewEmployee from "./Screens/Employee/ViewEmployee";
import DeleteEmployee from "./Screens/Employee/DeleteEmployee";
import TimeSheetList from "./Screens/Timesheet/TimeSheetList";
import TimeSheetEdit from "./Screens/Timesheet/TimeSheetEdit";
import AddTimesheet from "./Screens/Timesheet/AddTimesheet";
import AddInvoice from "./Screens/Invoice/AddInvoice";
import InvoiceTable from "./Screens/Invoice/InvoiceTable";
import ViewInvoice from "./Screens/Invoice/ViewInvoice";
import MasterScreen from "./Screens/Master/MasterScreen";
import Dashboard from "./Screens/Dashboard/DashboardPage";
import Incentivepage from "./Screens/Incentive/IncentivePage"
import AddIncentive from "./Screens/Incentive/AddIncentive";
import EmpMapping from "./Screens/EmpMapping/EmpMapping";
import AddMapping from "./Screens/EmpMapping/AddMapping";
import ConfigurationScreen from "./Screens/configuration/configurationscreen";
import ConfigurationHistoryScreen from "./Screens/configuration/ConfigurationHistoryScreen";
import Customers from "./Screens/Customer/Customers";
import AddCustomer from "./Screens/Customer/AddCustomer";
//import AddCustomer from "./Screens/Customer/AddCustomer";
import Projects from "./Screens/Project/Projects"; // adjust the path if needed
import AddProject from "./Screens/Project/AddProject";






const App: React.FC = () => {


  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/" element={<ResponsiveDrawer />}>
          <Route path="Dashboard" element={<Dashboard />} />

          <Route path="Projects" element={<Projects />} />
          <Route path="AddProject" element={<AddProject />} />

          


          {/* ExternalIncentive Routes */}
          <Route path="Incentivepage" element={<Incentivepage />} />
          <Route path="AddIncentive" element={<AddIncentive />} />

          <Route path="MasterScreen" element={<MasterScreen />} />
          {/* Employee Routes */}
          <Route
            path="EmployeeTable"
            element={<EmployeeTable/>}
          />
          <Route path="AddEmployee" element={<AddEmployee />} />
          <Route path="ViewEmployee" element={<ViewEmployee />} />
          <Route path="DeleteEmployee" element={<DeleteEmployee />} />

          {/* Timesheet Routes */}
          <Route path="timesheet" element={<TimeSheetList />} />
          <Route path="timesheet/edit/:id" element={<TimeSheetEdit />} />
          <Route path="timesheet/add" element={<AddTimesheet />} />
          {/* Customer Routes */}
         <Route path="/Customers" element={<Customers/>} />
         <Route path="/AddCustomer" element={<AddCustomer />} />

        


          {/* Invoice Routes */}
          <Route path="AddInvoice" element={<AddInvoice drawerOpen={true} />} />
          <Route
            path="InvoiceTable"
            element={<InvoiceTable drawerOpen={true} />}
          />
          <Route
            path="ViewInvoice"
            element={<ViewInvoice drawerOpen={true} />}
          />

          {/* EmpMapping Routes */}
          <Route path="EmpMapping" element={<EmpMapping />} />
          <Route path="AddMapping" element={<AddMapping />} />
          {/* {configuration} */}
          <Route path="configurationscreen" element={<ConfigurationScreen />} />

          <Route path="/configuration-history" element={<ConfigurationHistoryScreen />} />


        </Route>
      </Routes>
    </Router>
  );
};

export default App;
